"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._RadioGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = require("..");
var _context = require("../Form/context");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _RadioGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(_RadioGroup, _PureComponent);
  var _super = _createSuper(_RadioGroup);
  function _RadioGroup() {
    var _this;
    _classCallCheck(this, _RadioGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      error: ""
    });
    _defineProperty(_assertThisInitialized(_this), "radioGroup", /*#__PURE__*/(0, _react.createRef)());
    _defineProperty(_assertThisInitialized(_this), "isValid", function () {
      var _this$props = _this.props,
        required = _this$props.required,
        checked = _this$props.checked;
      if (!required) return true;
      if (!(checked !== null && checked !== void 0 && checked.label)) return false;
      return true;
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      if (!_this.isValid()) {
        _this.setState({
          error: "Field required"
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      return _this.setState({
        error: ""
      });
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {});
    _defineProperty(_assertThisInitialized(_this), "onChange", function (o) {
      _this.setState({
        error: ""
      });
      _this.props.onChange(o);
    });
    _defineProperty(_assertThisInitialized(_this), "getRef", function () {
      return _this.radioGroup.current;
    });
    return _this;
  }
  _createClass(_RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.attachToForm) {
        this.props.attachToForm(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.removeFromForm) {
        this.props.removeFromForm(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _columnDirection,
        _this2 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        checked = _this$props2.checked,
        showError = _this$props2.showError,
        renderRadio = _this$props2.renderRadio;
      var columnDirection = this.props.columnDirection;
      columnDirection = (_columnDirection = columnDirection) !== null && _columnDirection !== void 0 ? _columnDirection : true;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-checkbox-group ".concat(columnDirection && 'column-direction'),
        ref: this.radioGroup
      }, data.map(function (o, i) {
        var props = {
          key: i,
          onChange: function onChange() {
            return _this2.onChange(o);
          },
          label: o.label,
          checked: (checked === null || checked === void 0 ? void 0 : checked.label) === o.label,
          disabled: false,
          square: false
        };
        return renderRadio ? renderRadio(props, i, o) : /*#__PURE__*/_react.default.createElement(_.Checkbox, props);
      }), !!this.state.error && !!showError && /*#__PURE__*/_react.default.createElement("p", {
        className: "sa-checkbox-group-error"
      }, this.state.error));
    }
  }]);
  return _RadioGroup;
}(_react.PureComponent);
exports._RadioGroup = _RadioGroup;
var RadioGroup = /*#__PURE__*/function (_PureComponent2) {
  _inherits(RadioGroup, _PureComponent2);
  var _super2 = _createSuper(RadioGroup);
  function RadioGroup() {
    _classCallCheck(this, RadioGroup);
    return _super2.apply(this, arguments);
  }
  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement(_context.FormConsumer, null, function (context) {
        return /*#__PURE__*/_react.default.createElement(_RadioGroup, _extends({}, _this3.props, {
          attachToForm: context === null || context === void 0 ? void 0 : context.attachToForm,
          removeFromForm: context === null || context === void 0 ? void 0 : context.removeFromForm
        }));
      });
    }
  }]);
  return RadioGroup;
}(_react.PureComponent);
exports.default = RadioGroup;